import styled from "styled-components"; 

export const ContainerOrdenes = styled.div`
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
`;